import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import Icon from '@app/components/Icon/index';

interface IProps {
    onClick: () => void;
}

export const Reset2faTokenRow: React.SFC<IProps> = ({onClick }) => {
    const { translation } = useTypedTranslation();

    return <>
        <div className='forgot-password__reset-password-wrapper' onClick={onClick}>
            <Icon icon='resetPassword2FaIco' className='forgot-password__user-icon reset-twoFA' />
            <div className='forgot-password__reset-password-text'>
                <div className='forgot-password__form-title'>{translation('RESET_MFA_TOKEN')}</div>
                <div className='forgot-password__form-short-text'>{translation('RESET_MFA_TOKEN_DESCRIPTION')}</div>
            </div>
        </div>
    </>;
};
